import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Tabs, Divider, Button, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Helmet } from "react-helmet";
import DisbursementContainer from "../disbursement";
import TransactionReports from "../transactionReports";
import NotificationSettings from "../notificationSettings";

const style = (theme) => ({
  indicator: {
    border: "0.5px solid",
    borderColor: theme.palette.primary.main,
  },
  scroll: {
    width: "min-content",
  },
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    gridTemplateColumns: "6fr 4fr 1fr 2fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  inputRoot: {
    fontWeight: 500,
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    paddingLeft: "10px !important",
  },
  dropdownSearchBox: {
    backgroundColor: "#E9EDEF",
    borderRadius: 4,
  },
  select: {
    minWidth: 170,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      minWidth: "auto",
    },
  },
  textFieldInput: {
    padding: "7px",
    paddingTop: "8px",
    minWidth: 170,
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  menuItemText: {
    padding: 10,
    fontWeight: 500,
  },
  exportButton: {
    backgroundColor: "#ffffff",
    height: 43,
    borderRadius: 4,
    padding: "5px 12px",
    borderColor: "#D0D5DD",
  },
});

const useStyles = makeStyles(style);

export default function MainPageComponent({
  handleChange,
  activeIndex,
  tabLabels,
  disbursementSubTabs,
  disbursementActiveIndex,
  disbursementHandleChange,
  canViewNotificationSettings,
}) {
  const classes = useStyles();

  function a11yProps(index, label = "label") {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tab-${index}`,
      label: <Typography variant="button">{label}</Typography>,
    };
  }

  function DisbursementSubTabs() {
    const disbursementTabLabels = [
      "Companies",
      "Transaction Reports",
      ...(canViewNotificationSettings ? ["Notification Settings"] : []),
    ];

    return (
      <Box>
        <Box px={2}>
          <Tabs
            value={disbursementActiveIndex || 0}
            onChange={disbursementHandleChange}
            aria-label="disbursement sub tabs"
            variant="scrollable"
            textColor="inherit"
            classes={{
              indicator: classes.indicator,
              scrollButtons: classes.scroll,
            }}
          >
            {disbursementTabLabels.map((item, index) => (
              <Tab
                className={classes.tab}
                key={index}
                {...a11yProps(index, item)}
              />
            ))}
          </Tabs>
        </Box>

        <Box>
          {disbursementActiveIndex !== null &&
            disbursementTabLabels.map((item, index) => {
              if (item === "Companies") {
                return (
                  <TabPanel
                    value={disbursementActiveIndex}
                    index={index}
                    key={index}
                  >
                    <Box className={classes.panel}>
                      <DisbursementContainer />
                    </Box>
                  </TabPanel>
                );
              }

              if (item === "Transaction Reports") {
                return (
                  <TabPanel
                    value={disbursementActiveIndex}
                    index={index}
                    key={index}
                  >
                    <Box className={classes.panel}>
                      <TransactionReports />
                    </Box>
                  </TabPanel>
                );
              }

              if (item === "Notification Settings") {
                return (
                  <TabPanel
                    value={disbursementActiveIndex}
                    index={index}
                    key={index}
                  >
                    <Box className={classes.panel}>
                      <NotificationSettings />
                    </Box>
                  </TabPanel>
                );
              }

              return null;
            })}
        </Box>
      </Box>
    );
  }

  function TabPanel({ children, value, index, ...other }) {
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  return (
    <Box>
      <Helmet>
        <title>Company Consumer Engagement | Kood Asia Management Portal</title>
      </Helmet>
      <Box p={2}>
        <Box gridArea="panel">
          <Box>
            <Box px={2}>
              <Tabs
                value={activeIndex || 0}
                onChange={handleChange}
                aria-label="scrollable auto tabs example"
                variant="scrollable"
                textColor="inherit"
                classes={{
                  indicator: classes.indicator,
                  scrollButtons: classes.scroll,
                }}
              >
                {tabLabels.map((item, index) => (
                  <Tab
                    className={classes.tab}
                    key={index}
                    {...a11yProps(index, item)}
                  />
                ))}
              </Tabs>
            </Box>

            <Box>
              {activeIndex !== null &&
                tabLabels.map((item, index) => {
                  if (item === "Disbursements") {
                    return (
                      <TabPanel value={activeIndex} index={index} key={index}>
                        <Box className={classes.panel}>
                          <DisbursementSubTabs />
                        </Box>
                      </TabPanel>
                    );
                  }

                  return null;
                })}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
